import Parser from 'html-react-parser';

export function toReact(html: string) {
  return Parser(html);
}

export function strip(html: string) {
  return html.replace(/(<([^>]+)>)/gi, '');
}
